import type { FeatureGateSeed } from './feature-gate-registry';

/**
 * The office type gate, spread into FEATURE_GATE_SEEDS in feature-gate-registry.ts. The row is
 * created by the office_type_select_feature_gate migration.
 */
export const OFFICE_TYPE_FEATURE_GATE_SEEDS = {
  office_type_select: {
    label: 'Office type',
    shortLabel: 'Office type',
    description:
      'Lets an office admin choose whether the office is a government or a corporate office in Office Profile settings, and lets set-org-profile accept the change. Not a sidebar item - off means the selector is hidden and set-org-profile refuses any change to the office type.',
    group: 'correspondence',
  },
} satisfies Record<string, FeatureGateSeed>;
